import React, { useRef, useEffect } from "react";
import { Modals } from "./ModalStyle";
import { useTranslation } from "react-i18next";

const Modal = ({ toggleModal }) => {
    const modalRef = useRef();
    const { t } = useTranslation();

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                toggleModal(false);
            }
        };

        document.addEventListener("click", handleOutsideClick);

        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, [toggleModal]);

    useEffect(() => {
        modalRef.current.classList.add("show");
    }, []);

    return (
        <Modals>
            <div ref={modalRef} className="modal">
                <div className="modal-content">
                    <header>
                        <div className="close">
              <button className="close-btn" onClick={() => toggleModal(false)}>
                &times;
              </button>
                        </div>
                    </header>
                    <div>
                        <div className="result-subtitle">
                        {t('modalText')}
                        </div>
                    </div>
                    <footer></footer>
                </div>
            </div>
        </Modals>
    );
};

export default Modal;
